import slotMixin from './game/slotMixin'
import gameBannerMixin from './banner/gameBannerMixin'
import gameMixin from './game/gameMixin'
import applyBonus from './bonus/applyBonus'
import queryBonusBindUserInfoList from './bonus/queryBonusBindUserInfoList'
import bannerCodeImg from './banner-codeImg/bannerCodeImg'
import gameMaintain from './game/game-maintain'
import bankcardList from './bankcard/bankcardList'
import slotWinner from './random-slot-winner/slot-winner'
import oldGetBanner from './oldGetBanner/oldGetBanner'
export {
  slotMixin,
  gameMixin,
  gameBannerMixin,
  applyBonus,
  queryBonusBindUserInfoList,
  bannerCodeImg,
  gameMaintain,
  bankcardList,
  slotWinner,
  oldGetBanner
}



// WEBPACK FOOTER //
// ./src/common/mixins/index.js